( function( $ ) {

    $( function( $ ) {
    
        $(document).on('click', '.js-quantityPlus', function() {
            let $input = $(this).closest('.js-quantity').find('input.qty');
            let currentValue = parseInt($input.val());
            let maxValue = parseInt($input.attr('max'));
            let newValue = currentValue + 1;
            if ( maxValue && newValue > maxValue) {
                return;
            }
            $input.val(newValue);
            $input.trigger('change');
        });

        $(document).on('click', '.js-quantityMinus', function() {
            let $input = $(this).closest('.js-quantity').find('input.qty');
            let currentValue = parseInt($input.val());
            let minValue = Math.max(parseInt($input.attr('min')), 0);
            let newValue = currentValue - 1;
            if ( newValue < minValue) {
                return;
            }
            $input.val(newValue);
            $input.trigger('change');
        });

    } );

} ) ( jQuery );